import { types } from 'store/modules/mentor';

const mentorFetchSucceeded = ({ mentorData }) => ({
  type: types.MENTOR_FETCH_SUCCEEDED,
  payload: mentorData,
});

const mentorFetchFailed = ({ message }) => ({
  type: types.MENTOR_FETCH_FAILED,
  payload: message,
});

const mentorEdit = ({ id, ...mentorData }, callback) => ({
  type: types.MENTOR_EDIT,
  payload: { id, ...mentorData },
  callback,
});

const mentorEditSucceeded = data => ({
  type: types.MENTOR_EDIT_SUCCEEDED,
  payload: data,
});

const mentorEditFailed = ({ message }) => ({
  type: types.MENTOR_EDIT_FAILED,
  payload: message,
});

const mentorSelectedFetch = ({ mentorData }) => ({
  type: types.MENTOR_SELECTED_FETCH,
  payload: mentorData,
});

const mentorSelectedFetchSucceeded = action => ({
  type: types.MENTOR_SELECTED_FETCH_SUCCEEDED,
  payload: action,
});

const mentorSelectedFetchFailed = ({ message }) => ({
  type: types.MENTOR_SELECTED_FETCH_FAILED,
  payload: message,
});

export default {
  mentorFetchSucceeded,
  mentorFetchFailed,
  mentorEdit,
  mentorEditSucceeded,
  mentorEditFailed,
  mentorSelectedFetch,
  mentorSelectedFetchSucceeded,
  mentorSelectedFetchFailed,
};
